import React from 'react';
import classNames from 'classnames';

export interface AttributeRowProps {
  title?: React.ReactNode;
  editable?: boolean;
  children: React.ReactNode;
}

const AttributeRow: React.FC<AttributeRowProps> = ({
  title,
  editable = true,
  children,
}) => {
  return (
    <div
      className={classNames('attribute__row', {
        'attribute__row--editable': editable,
      })}
    >
      {title && (
        <div className='attribute__title'>
          <div className='attribute__title-background' />
          <span className='attribute__name'>
            <span className='attribute__name--inner'>{title}</span>
          </span>
        </div>
      )}

      <div className='attribute__value'>
        <div className='attribute__value-background' />
        <div className='attribute__value-container'>
          <div className='attribute__value-input'>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AttributeRow;
